import { useState } from 'react';
import { useAppSelector } from '../../../Hooks/Hooks';
import { RootState } from '../../../Redux/Store';
import './TermsAndConditions.scss';

const TermsAndConditions = (props: any) => {
  const { showToggle = false } = props;
  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <div className="TC_Container">
      <div className="TC_Container_Heading">
        <span>Terms & Conditions</span>
        {showToggle && (
          <img
            src={`/oo/assets/icon/${isExpanded ? 'minus-icon' : 'plus'}.svg`}
            alt="expand icon"
            onClick={() => setIsExpanded(!isExpanded)}
          />
        )}
      </div>
      {((showToggle && isExpanded) || !showToggle) && (
        <p
          className="Booking_Terms"
          dangerouslySetInnerHTML={{
            __html: contentStackData?.booking_terms?.[0]?.content,
          }}
        />
      )}
    </div>
  );
};

export default TermsAndConditions;
